import { render, staticRenderFns } from "./greenProject.vue?vue&type=template&id=2fc68bac&scoped=true"
import script from "./greenProject.vue?vue&type=script&lang=js"
export * from "./greenProject.vue?vue&type=script&lang=js"
import style0 from "./greenProject.vue?vue&type=style&index=0&id=2fc68bac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc68bac",
  null
  
)

export default component.exports